import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
  header: {
    backgroundColor: capitalDesignTokens.semanticColors.background.primary,
    padding: "16px 24px 8px 24px",
  },
  title: {
    color: capitalDesignTokens.semanticColors.foreground.primary,
  },
  headerContent: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  buttons: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
});
